import request from "../../utils/request";

const API_ROUTE = `${process.env.REACT_APP_BASE_API}api/v1`;

export async function getAdminApi() {
  return request(`${API_ROUTE}/admins`, {
    method: "GET",
  });
}

export async function addAdminApi(body) {
  return request(`${API_ROUTE}/admins`, {
    method: "POST",
    data: body,
  });
}

export async function deleteAdminApi(id) {
  return request(`${API_ROUTE}/admins/${id}`, {
    method: "DELETE",
  });
}

export async function updateAdminApi(id, body) {
  return request(`${API_ROUTE}/admins/${id}`, {
    method: "PUT",
    data: body,
  });
}

export async function checkIsAdminApi() {
  return request(`${API_ROUTE}/checkIsAdmin`, {
    method: "GET",
  });
}
